<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showApplianceMenu="true" @on-selected="toolBarSelected">
              <template slot="appliancesMenu">
                <appliances-menu @on-selected="applianceSelect"></appliances-menu>
              </template>
          </graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="xrangeChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import appliancesMenu from "./components/AppliancesGroupMenu";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";

import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import format from "date-fns/format";
import { getAppliancesList } from "./components/functions.js";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    appliancesMenu
  },
  data() {
    return {
      chartOptions: null,
      toolBarData: null,
      appliancesData: null
    };
  },

  created() {
    const phaseLang = this.$lang.charts.phase;
    const energyLang = this.$lang.charts.energy_consumption;
    const durationLang = this.$lang.charts.duration;
    const runtimeLang = this.$lang.charts.runtime;

    this.chartOptions = {
      phase: this.$lang.charts.phase,
      time: {
        useUTC: false
      },
      chart: {
        type: "xrange",
        zoomType: "x"
      },

      boost: {
        enabled: true,
        useGPUTranslations: true,
        usePreAllocated: true
      },
      
      title: {
        text: this.$lang.charts.appliances_timeline
      },
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: {
          second: "%e.%m.%Y  %H:%M:%S"
        }
      },
      yAxis: {
        title: {
          text: ""
        },
        categories: [],
        reversed: true,
      },
      tooltip: {
        dateTimeLabelFormats: {
          second: "%e.%m.%Y  %H:%M:%S"
        },
        formatter: function() {
          return (
            "<b>" +
            this.series.yAxis.categories[this.point.y] +
            "</b><br>" +
            "<b>"+runtimeLang+" </b> " +
            format(this.point.x, "HH:mm:ss DD/MM/YYYY") +
            " - " +
            format(this.point.x2, "HH:mm:ss DD/MM/YYYY") +
            "<br>" +
            "<b>"+durationLang+" </b> " +
            this.point.duration +
            " s<br>" +
            "<b>"+phaseLang+" </b> " +
            this.point.phase +
            "<br>" +
            "<b>"+energyLang+" </b> " +
            this.point.energy +
            " Wh<br>" +
            "<br>" +
            "<b>"+"Computed edge "+" </b> " +
            this.point.computed +
            " <br>"
          );
        }
      },
      plotOptions: {
        xrange: {
          showInLegend: false,
          //cursor: "pointer"
        }
      },
      credits: {
        enabled: false
      },
      series: [
        {
          borderColor: "gray",
          pointWidth: 20,
          data: [],
          dataLabels: {
            enabled: true
          }
        }
      ],
      scrollbar: {
        enabled: true,
        liveRedraw: true,
        showFull: false
      }
    };

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
    
  },

  methods: {

    applianceSelect(data){
      this.appliancesData = data;
      if (this.toolBarData){
        this.getAPIData(this.toolBarData, this.appliancesData);
      }
    },

    toolBarSelected(data){
      this.toolBarData = data;
      if (this.appliancesData){
        this.getAPIData(this.toolBarData, this.appliancesData);
      }
    },

    getAPIData(selected, appliancesGroup) {
      const { chart } = this.$refs.xrangeChart;
      chart.showLoading();
      chart.yAxis[0].setCategories([], false);

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/nilm/runtime",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          phase: "L1,L2,L3",
          from: selected.date.from,
          to: selected.date.to,
          microseconds: true
        },
        withCredentials: true
      })
        .then(response => {
            let chartData = [];
            let applianceFiltered = getAppliancesList(appliancesGroup);
              
              response.data.data.forEach(el => {
                const dataIndex = applianceFiltered.findIndex(resp => resp.ID === el.ID_appliance);

                if (dataIndex !== -1){
                  const category = el.name;
                  let categoryIndex = chart.yAxis[0].categories.findIndex(
                    e => e == category
                  );

                  if (categoryIndex == -1) {
                    chart.yAxis[0].categories.push(category);
                    categoryIndex = chart.yAxis[0].categories.findIndex(
                      e => e == category
                    );
                  }

                  chartData.push({
                    x: el.start,
                    x2: (el.end > el.start) ? el.end : el.start,
                    y: categoryIndex,
                    phase: el.phase,
                    energy: el.energy,
                    duration: el.duration,
                    ID_appliance: el.ID_appliance,
                    computed: el.computed
                  });
                }
              });

            chart.series[0].setData(chartData, false, false, false);
            chart.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          if (error.response.data.code == 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
            chart.series[0].setData([]);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>